import React from "react";
/* istanbul ignore file */
interface PageBreakProps {
  className?: string;
}

export const PageBreak: React.FC<PageBreakProps> = ({ className }) => {
  return <div data-break-before="always" className={className} />;
};

export default PageBreak;
